import _ from 'lodash';
import React from 'react';
import {Row,Col} from 'react-bootstrap'
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import MdDelete from 'react-icons/lib/md/delete'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom'
import MdArrowBack from 'react-icons/lib/md/arrow-back'

class EditMember extends React.Component{

	constructor(props) {
	    super(props);
		this.state = {
			file: '',
			imagePreviewUrl: '',
			value: 1,
			name: '',
			email: '',
			type: false,
			userName: '',
			userEmail: '',
			typeChanged:false,
			changeName: false,
			changeEmail: false,
			chanegType: false
		};
		this.editProfileSubmit=this.editProfileSubmit.bind(this);
		this.handleChangeName=this.handleChangeName.bind(this);
		this.handleChangeEmail=this.handleChangeEmail.bind(this);
		this.deleteMember= this.deleteMember.bind(this);
		
	}
	handleChangeName(e){
		this.setState({userName:e.target.value,changeName: true});
	}
	handleChangeEmail(e){
		this.setState({userEmail:e.target.value,changeEmail: true});
	}
 	handleChange = (event, index, value) => {
 		this.setState({value})
 		this.setState({chanegType: true});
 	};
 	
  	_handleImageChange(e) {
    	e.preventDefault();
    	let reader = new FileReader();
    	let file = e.target.files[0];
    	reader.onloadend = () => {
      		this.setState({
		        file: file,
		        imagePreviewUrl: reader.result
	      	});
	    }
	    reader.readAsDataURL(file)
	}
	editProfileSubmit(e){
		e.preventDefault();
		var name  = document.EditProfile.fullname.value;
        var type  = this.state.value;
        var email = document.EditProfile.email.value;
        
        var id = document.EditProfile.userId.value;
        var loginUserId='';
        let companyId='';
        if(!this.props.EditMemberId){
        	loginUserId=this.props.loginUser.currentUser._id;
        	companyId = this.props.currentuser.company._id;
        }
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var regxName = /^[a-zA-Z ]{1,40}$/;
        var validation='true';
        if(name===''){
            this.setState({name:'Name is a required field.'});
            validation='false';
            return false;
        }else{
        	this.setState({name:''});
        }
        if(name!=''){
        	if(!regxName.test(name)){
                this.setState({name:'Please input a valid name.'});
                return false;
            }else{
                this.setState({name:''});
            }
        }
        if(type===''){
            this.setState({type:true});
            validation='false';
        }
        if(email===''){
            this.setState({email:'Email is a required field.'});
            validation='false';
            return false;
        }else{
        	this.setState({email:''});
        }
        if(email!=''){
            if(!re.test(email)){
                this.setState({email:'Please input a valid email.'});
                return false;
            }else{
                this.setState({emai:''});
            }
        }
        
        if(validation==='true'){
        	if(loginUserId!==''){
        		this.props.addMemberSave(name,type,email,loginUserId, companyId);
        	}else{
            	this.props.editMemberSave(name,type,email,id);
        	}
        }
	}
	setType(usertype){
		this.setState({value:usertype});
		this.setState({typeChanged:true});
	}
	editMemberDetail(userId){
		let member= _.filter(this.props.currentuser.companymembers,{ _id : userId});
		return member;
	}
	deleteMember(e){
		this.props.deleteTeam(e);
	}
	render(){
		let editMemberDetail=this.editMemberDetail(this.props.EditMemberId);
        let userName =  editMemberDetail[0]? editMemberDetail[0].name : '';
    	let userEmail = editMemberDetail[0] ? editMemberDetail[0].email : '';
    	let usertype = editMemberDetail[0] ? editMemberDetail[0].type : null;
    	let loginUserType= this.props.currentuser.currentUser?this.props.currentuser.currentUser.type : null;
    	let loginUserEmail= this.props.currentuser.currentUser?this.props.currentuser.currentUser.email : null;
    	if(usertype && !this.state.typeChanged){
    		this.setType(usertype);
    	}
		return(<div>
					
					<div className="dashboard-page">
						<div className="right-content-dashboard active-dashboard">
							<div className="change-password-content">
								<Row>
									<form name="EditProfile" onSubmit={this.editProfileSubmit}>
										<Col md={8}>
											<div className="chenge-password-form">
												<div className="heading-sec">
													<h2><Link to="/user-account"><MdArrowBack /></Link>{!this.props.EditMemberId? "Add User" : "Edit User" }</h2>
												</div>
												 
				                                     <Row>
				                                        <Col md={12}>
				                                            <TextField
				                                                fullWidth={ true }
				                                                floatingLabelText="Full Name"
				                                                type="text"
				                                                name="fullname"
				                                                value={userName && !this.state.changeName? userName:this.state.userName}
				                                                onChange={this.handleChangeName}
				                                                errorText={this.state.name}
				                                                disabled={this.props.EditMemberId? true: false}
				                                            />
				                                        </Col>
				                                    </Row>
				                                    <Row>
				                                        <Col md={12}>
		                                                    <SelectField
		                                                     fullWidth={ true }
													          floatingLabelText="Account Type"
													          value={this.state.value}
													          onChange={((this.props.EditMemberId && loginUserType===1) || !this.props.EditMemberId) && (loginUserEmail!==userEmail)?this.handleChange:null}//condition of admin
													          required={this.state.type}
													          disabled={this.state.value===1 && this.state.chanegType===false && this.props.EditMemberId?true:false}
													          name='membertype'
													        >
													          <MenuItem value={1} primaryText="Admin" />
													          <MenuItem value={2} primaryText="Team Member" />
													          
													        </SelectField>
				                                        </Col>
				                                    </Row>
				                                    <Row>
				                                        <Col md={12} className="margb20px" >
				                                            <TextField
				                                                fullWidth={ true }
				                                                floatingLabelText="Primary Email"
				                                                type="email"
				                                                name="email"
				                                                onChange={this.handleChangeEmail}
				                                                value={userEmail && !this.state.changeEmail? userEmail:this.state.userEmail}
				                                                errorText={this.state.email}
				                                                disabled={this.props.EditMemberId? true: false}
				                                            />
				                                        </Col>
				                                    </Row>
				                                    <Row>
				                                        <Col md={12}>
				                                        	<input type='hidden' name="userId" value={this.props.EditMemberId}/>
				                                          <div className="submit-buttton">
				                                           <RaisedButton label={!this.props.EditMemberId? "Add User":"Update User"} type="submit" labelColor="#fff" fullWidth={false} />
				                                          	{this.props.EditMemberId?
				                                          		<FlatButton 
																    label="Delete User" 
																    className="cancel-btn"
																    labelStyle={{'fontWeight': '600' , 'textAlign':'left', color: '#e94731'}}
																    icon={<MdDelete color="#e94731" />}
																    disabled={(this.props.EditMemberId && usertype===2)?false:true}
																    onClick={(e)=>this.deleteMember(this.props.EditMemberId)}
																/>
				                                          	: null}
				                                          </div>
				                                        </Col>
				                                    </Row>
											</div>
										</Col>
									</form>
								</Row>
							</div>
						</div>
					</div>
			   </div>
			)
	}
}

const mapStateToProps= (state,{ match })=> {
	const userId=match.params.userId;
    return {
      currentuser: state.login,
      EditMemberId : userId,
    };
}
export default withRouter(connect(mapStateToProps)(EditMember));


// WEBPACK FOOTER //
// ./src/Components/Pages/EditMember.js